import { Link } from "react-router-dom";
import { articles, getCategoryBySlug } from "@/mocks/news";
import { formatViews } from "@/utils/format";

export default function Hero() {
  const breaking = articles.find((a) => a.breaking);
  const lead = breaking || articles[0];
  const quick = articles.filter((a) => a.id !== lead.id).slice(0, 4);

  return (
    <section className="bg-gradient-to-b from-primary-50/70 via-background-50 to-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-6 md:pt-8 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6">
          {/* 头条大图 */}
          <article className="lg:col-span-2 group relative overflow-hidden rounded-xl">
            <Link to={`/news/${lead.id}`} className="block relative" aria-label={lead.title}>
              <div className="relative h-[340px] md:h-[480px] w-full overflow-hidden">
                <img
                  src={lead.cover}
                  alt={lead.title}
                  title={`${lead.title} - 每日爆料头条`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
              </div>
              <div className="absolute left-5 right-5 bottom-0 pb-6">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="inline-flex items-center gap-1.5 bg-primary-600 text-background-50 text-xs px-2.5 py-1 rounded-sm font-medium">
                    <i className="ri-flashlight-fill pulse-dot"></i>刚刚 · 重磅
                  </span>
                  <span className="inline-flex items-center bg-foreground-950/40 text-background-50 text-xs px-2.5 py-1 rounded-sm">
                    {getCategoryBySlug(lead.category)?.name}爆料
                  </span>
                </div>
                <h1 className="font-heading text-2xl md:text-4xl font-black text-background-50 leading-snug md:leading-tight max-w-3xl group-hover:text-accent-300 transition-colors">
                  {lead.title}
                </h1>
                <p className="hidden md:block mt-3 text-sm text-background-200/90 leading-relaxed max-w-2xl line-clamp-2">
                  {lead.summary}
                </p>
                <div className="mt-4 flex items-center gap-5 text-xs text-background-200/80">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-3-line"></i>{lead.author}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>{lead.time}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line"></i>{formatViews(lead.views)}
                  </span>
                  <span className="hidden sm:flex items-center gap-1 text-accent-300 font-medium">
                    立即阅读<i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          </article>

          {/* 即时头条列表 */}
          <div className="bg-background-50 border border-background-200 rounded-xl p-5 flex flex-col">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
                <span className="relative flex w-2.5 h-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary-600"></span>
                </span>
                即时头条
              </h2>
              <span className="text-xs text-primary-700 font-medium flex items-center gap-1">
                <i className="ri-refresh-line"></i>自动刷新
              </span>
            </div>
            <ul className="flex-1 divide-y divide-background-100/80">
              {quick.map((a, i) => (
                <li key={a.id}>
                  <Link to={`/news/${a.id}`} className="group flex gap-4 py-4 items-start">
                    <span className="font-heading text-2xl font-black text-background-300 leading-none select-none">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h3 className="text-[15px] font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                        {a.title}
                      </h3>
                      <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                        <span className="text-primary-700 font-medium">{getCategoryBySlug(a.category)?.name}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>{a.time}
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/category/keji"
              className="mt-3 text-center text-sm text-primary-700 hover:text-primary-600 font-medium"
            >
              查看全部实时快讯 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}